<template>
  <div class="comp-ly-list-batch-buttons">
    <div class="batch-left">
      <span>{{ $t('已选择') }}&nbsp;{{ selectTableIds.length }}&nbsp;{{ $t('条') }}</span>
      <!-- 转移 -->
      <jw-button size="mini" v-if="userInfo?.roles?.indexOf(`${oem[entity]}:transfer`) !== -1 && btnPermission.indexOf(`${oem[entity]}:transfer`) > -1" @click="leadBatch" style="margin-left: 20px">{{ buttonTexts?.[`${oem[entity]}:transfer`] }}</jw-button>
      <!-- 批量转移 -->
      <jw-button size="mini" v-if="userInfo?.roles?.indexOf(`${oem[entity]}:batchTransfer`) !== -1 && btnPermission.indexOf(`${oem[entity]}:batchTransfer`) > -1" @click="leadBatch" style="margin-left: 20px">{{ buttonTexts?.[`${oem[entity]}:batchTransfer`] }}</jw-button>
      <!-- 领取 -->
      <jw-button size="mini" :loading="data.poolLoading" v-if="userInfo?.roles?.indexOf(`${oem[entity]}:receive`) !== -1 && btnPermission.indexOf(`${oem[entity]}:receive`) > -1" @click="collectionClue" style="margin-left: 20px"> {{ buttonTexts?.[`${oem[entity]}:receive`] }} </jw-button>
      <!-- 分配 -->
      <jw-button size="mini" v-if="userInfo?.roles?.indexOf(`${oem[entity]}:allocation`) !== -1 && btnPermission.indexOf(`${oem[entity]}:allocation`) > -1" @click="distribution" style="margin-left: 20px"> {{ buttonTexts?.[`${oem[entity]}:allocation`] }} </jw-button>
      <!-- 退回 -->
      <jw-button size="mini" v-if="userInfo?.roles?.indexOf(`${oem[entity]}:return`) !== -1 && btnPermission.indexOf(`${oem[entity]}:return`) > -1" @click="leadReturn" style="margin-left: 20px"> {{ buttonTexts?.[`${oem[entity]}:return`] }} </jw-button>
      <!-- 批量退回 -->
      <jw-button size="mini" v-if="userInfo?.roles?.indexOf(`${oem[entity]}:batchReturn`) !== -1 && btnPermission.indexOf(`${oem[entity]}:batchReturn`) > -1" @click="leadReturn" style="margin-left: 20px"> {{ buttonTexts?.[`${oem[entity]}:batchReturn`] }} </jw-button>
      <!-- 客户/商机/销售订单(充值同步数据)-->
      <jw-button size="mini" v-if="userInfo?.roles?.indexOf(`${oem[entity]}:bingDataSync`) !== -1 && btnPermission.indexOf(`${oem[entity]}:bingDataSync`) > -1 && props.selectType == 0" @click="batchBingData(entity)" style="margin-left: 20px"> {{ buttonTexts?.[`${oem[entity]}:bingDataSync`] }} </jw-button>
      <!-- 批量编辑 -->
      <jw-button size="mini" v-if="userInfo?.roles?.indexOf(`${oem[entity]}:batchEdit`) !== -1 && btnPermission.indexOf(`${oem[entity]}:batchEdit`) > -1" @click="bulkEditingClick" style="margin-left: 20px">{{ buttonTexts?.[`${oem[entity]}:batchEdit`] }}</jw-button>
      <!-- 邀请同步数据 -->
      <template v-if="entity >= 200">
        <jw-button size="mini" :loading="loading" v-if="userInfo?.roles?.indexOf(`${entity}:bingUserInviteSync`) !== -1 && btnPermission.indexOf(`${entity}:bingUserInviteSync`) > -1 && props.selectType == 0" @click="bingUserInviteSync()" style="margin-left: 20px"> {{ buttonTexts?.[`${entity}:bingUserInviteSync`] }} </jw-button>
      </template>
      <!-- 批量删除 -->
      <jw-button size="mini" v-if="buttonShortcut.indexOf(`${oem[entity]}:delete`) !== -1 && userInfo?.roles?.indexOf(`${oem[entity]}:delete`) !== -1 && userInfo?.roles?.indexOf(`${oem[entity]}:deleteBatch`) !== -1 && btnPermission.indexOf(`${oem[entity]}:deleteBatch`) > -1" @click="deleteBatch" style="margin-left: 20px">批量删除</jw-button>
      <!-- 转移 S-->
      <xl-transfer ref="transferRef" @cb="resetSelected" :type="entity"></xl-transfer>
      <!-- 线索池转移 S-->
      <xl-pool-transfer ref="poolTransferRef" @cb="resetSelected" :type="entity"></xl-pool-transfer>
      <!-- 分配 -->
      <xl-distribution ref="distributionRef" @cb="resetSelected"></xl-distribution>
      <!-- 退回 -->
      <xl-return ref="returnRef" @cb="resetSelected"></xl-return>
      <!-- 单字段批量编辑 -->
      <bulk-editing ref="bulkEditingRef" @cb="resetSelected"></bulk-editing>
      <!-- 批量删除 -->
    </div>

    <div class="batch-right" v-if="userInfo?.roles?.indexOf(`${oem[entity]}:dataCheck`) !== -1 && btnPermission.indexOf(`${oem[entity]}:dataCheck`) > -1">
      <!-- 数据校准 -->
      <jw-dropdown position="br" @select="handleSelect" class="data-check-btn" popup-container=".batch-right">
        <icon-more class="calibration" />
        <template #content>
          <jw-doption>
            <jw-button size="medium" type="text" @click="openCaliBration" class="calibration-btn">
              <template #icon v-if="buttonIcons?.[`${oem[entity]}:dataCheck`] && (buttonType?.[`${oem[entity]}:dataCheck`] == 0 || buttonType?.[`${oem[entity]}:dataCheck`] == 1)">
                <component :is="buttonIcons?.[`${oem[entity]}:dataCheck`]" />
              </template>
              <span>{{ buttonTexts?.[`${oem[entity]}:dataCheck`] }}</span>
            </jw-button>
          </jw-doption>
        </template>
      </jw-dropdown>
    </div>

    <jw-modal v-model:visible="data.deleteBatchVisible" @close="deleteBatchModalClose" :closable="!data.deleteBatchLoading" :esc-to-close="false" :mask="true" :mask-closable="data.maskClosable" title-align="start">
      <template #title>
        <!-- <div class="delete-batch-title"> -->
        <template v-if="data.isDeleteBatchIng == 0">批量删除确认</template>
        <template v-if="data.isDeleteBatchIng == 1">批量删除等待</template>
        <template v-if="data.isDeleteBatchIng == 2">批量删除完成</template>
        <!-- </div>F -->
      </template>
      <div>
        <div v-if="data.isDeleteBatchIng == 0">
          <div>
            已选<span class="deletebatch">{{ selectTableIds.length }}</span
            >条数据，删除后数据将不可恢复，是否确认？
          </div>
        </div>
        <div v-if="data.isDeleteBatchIng == 1">
          <span>后台数据处理中，请稍等...</span>
          <jw-progress :percent="data.percent" />
        </div>
        <div v-if="data.isDeleteBatchIng == 2" style="display: flex; align-items: center">
          <div v-if="data.failCount != selectTableIds.length">
            <span class="deletebatch">{{ data.successCount }}</span
            >条数据已删除
          </div>
          <div v-if="data.successCount != selectTableIds.length">
            <span v-if="data.successCount && data.failCount">,</span>
            <span class="deletebatch2">{{ data.failCount }}</span
            >条数据不可删除
          </div>
        </div>
      </div>
      <template #footer>
        <div v-if="data.isDeleteBatchIng == 0">
          <jw-button v-if="!data.deleteBatchLoading" style="margin-right: 8px" @click="deleteBatchHandleCancel">取消</jw-button>
          <jw-button :loading="data.deleteBatchLoading" @click="deleteBatchHandleOk" type="primary">确定</jw-button>
        </div>
        <div v-else>
          <!-- {{data.deleteBatchLoading}}-{{data.isDeleteBatchIng}} -->
          <jw-button @click="data.deleteBatchVisible = false" :loading="data.deleteBatchLoading" type="primary">{{ data.deleteBatchLoading ? '确认' : '关闭' }}</jw-button>
        </div>
      </template>
    </jw-modal>

    <jw-modal v-model:visible="data.calibrationVisible" :esc-to-close="false" :mask="true" title-align="start">
      <template #title>
        数据校准确认
        <jw-tooltip>
          <template #content>
            <ol class="calibration-list">
              <li>操作数据校准时，所选数据的所有计算字段都会重新计算</li>
              <li>单次操作数据量限制最多100条</li>
              <li>数据校准会引发该数据后续计算链条的数据重新计算</li>
            </ol>
          </template>
          <icon-exclamation-circle-fill class="calibration-icon" />
        </jw-tooltip>
      </template>
      <div class="calibration-wrap">已选{{ selectTableIds.length }}条数据，数据校准将会触发计算字段重新计算，是否确认?</div>
      <template #footer>
        <jw-space>
          <jw-button @click="cancelCaliBration">取消</jw-button>
          <jw-button type="primary" @click="handleCaliBration">确认</jw-button>
        </jw-space>
      </template>
    </jw-modal>
  </div>
</template>

<script setup>
import { reactive, ref, computed, onMounted, watch, inject, onUnmounted } from 'vue';
import { leadsService, publicService, formulaFieldService } from '@/api/';
import useOperation from '@/hooks/operation.js';
import { objEntityMapping } from '@/utils/const';
import { Message } from '@arco-design/web-vue';
import useLoading from '@/hooks/loading';
import { useUserStore } from '@/store';
import { tools } from '@/utils/tools';
import { useI18n } from 'vue-i18n';
console.log('1-开始创建组件-setup');
const { userInfo } = useUserStore(); //用户信息

console.log('用户信息', userInfo);

const { loading, setLoading } = useLoading(false); //loading
const emits = defineEmits(['cb']);
const { t } = useI18n();
const props = defineProps({
  entityId: {
    type: Number || String,
    default: null
  },
  filterParams: {
    type: Object,
    default: () => {}
  },
  fieldsListAll: {
    type: Object,
    default: () => {}
  },
  buttonShortcut: {
    type: Object,
    default: () => {}
  },
  selectIds: {
    type: Array,
    default: () => []
  },
  bingDataList: {
    type: Array,
    default: () => []
  },
  viewId: {
    type: Number || String,
    default: 0
  },
  listFields: {
    type: Array,
    default: () => []
  },
  tableDataLength: {
    type: Number || String,
    default: null || ''
  }
});
const data = reactive({
  // 是否显示数据校准弹窗
  calibrationVisible: false,
  // 是否显示批量删除弹窗
  deleteBatchVisible: false,
  // 删除进行中   0 未开始  1进行中 2结束
  isDeleteBatchIng: 0,
  // 点击遮罩是否关闭弹窗
  maskClosable: true,
  // 失败数
  failCount: 0,
  // 成功数
  successCount: 0,
  poolId: inject('defaultParams')?.poolId,
  deleteBatchLoading: false,
  // 进度值
  percent: 0
});
const oem = ref(JSON.parse(JSON.stringify(objEntityMapping)));
const filterParamsObj = computed(() => props.filterParams);
const entity = computed(() => props.entityId);
const btnPermission = computed(() => props.fieldsListAll);
const selectTableIds = computed(() => props.selectIds);
console.log(1265, filterParamsObj.value, entity.value, btnPermission.value, selectTableIds.value);
const { collection, isPoolManager } = useOperation();
// const poolId = computed(() => filterParamsObj.value?.conditions?.[0].children.find((item) => item.field === 'cluePoolId').value);
const distributionRef = ref(); // 分配线索
const transferRef = ref(); //转移
const poolTransferRef = ref(); // 线索池转移
const returnRef = ref(); //退回
const buttonIcons = ref(); // icon集合
const buttonType = ref(); // 按钮类型集合
/************************************************** */
const buttonTexts = ref({});
const getBtnPermissionObj = () => {
  buttonTexts.value = tools.getOptTextsByEntity(userInfo?.menus?.entityResources, entity.value);
  buttonIcons.value = tools.getIconsByEntity(userInfo?.menus?.entityResources, entity.value);
  buttonType.value = tools.getShowTypeByEntity(userInfo?.menus?.entityResources, entity.value);
};
/************************************************** */
// 领取线索
const collectionClue = () => {
  try {
    const params = {
      businessIds: selectTableIds.value,
      poolId: data.poolId
    };
    data.poolLoading = true;
    collection(params).then((res) => {
      data.poolLoading = false;
      // console.log('@@@@@', res, data.poolId);
      if (res) {
        resetSelected();
      }
    });
  } catch (e) {
    data.poolLoading = false;
    console.log(e);
  }
};
// 分配线索
const distribution = async () => {
  const result = await isPoolManager({
    poolId: data.poolId
  });
  if (result) {
    const params = {
      businessIds: selectTableIds.value,
      poolId: data.poolId,
      title: t('分配')
    };
    distributionRef.value.transferShow(params);
  } else {
    Message.error(t('您非线索池管理员，不可分配线索'));
  }
};

/*************************************************批量删除******************************************************/
let timerSId;

// 计算字段数据校准
const handleCaliBration = async () => {
  if (selectTableIds.value.length > 100) {
    Message.error('单次操作数据量限制最多100条');
    return;
  }
  try {
    const json = await formulaFieldService.calculationCalibration({
      entityId: entity.value,
      businessIds: selectTableIds.value
    });
    if (!json.error) {
      Message.success('操作成功');
      cancelCaliBration();
      resetSelected();
    } else {
      Message.error(json.error?.msg || t('操作失败'));
      cancelCaliBration();
      resetSelected();
    }
  } catch (error) {
    console.log(error);
  }
};
// 批量删除确认
const deleteBatchHandleOk = async () => {
  data.maskClosable = false;
  try {
    data.deleteBatchLoading = true;
    increaseProgress();
    data.isDeleteBatchIng = 1;
    const json = await publicService.removeBatch({ entity: entity.value, businessId: selectTableIds.value || [] });
    if (!json.error) {
      data.percent = 1;
      //2025年03月18日18:31:48 产品要求动画效果使用延时
      timerSId = setTimeout(() => {
        data.deleteBatchLoading = false;
        data.isDeleteBatchIng = 2;
        data.failCount = json.result?.failCount;
        data.successCount = json.result?.successCount;
      }, 500);
    } else {
      clearProgressTimer();
      Message.error(json.error?.msg || t('操作失败'));
    }
    if (json.result?.failCount > 0) {
      data.maskClosable = true;
    } else {
      data.deleteBatchVisible = false;
      Message.success(`${json.result.successCount}条数据已删除成功`);
      resetSelected();
    }
  } catch (e) {
    console.log(e);
    data.deleteBatchLoading = false;
    data.isDeleteBatchIng = 1;
    data.maskClosable = true;
    clearProgressTimer();
  }
};
let timerId;
// 批量删除进度条
const increaseProgress = (num = 0) => {
  data.percent = data.percent * 1 > 0.95 ? data.percent * 1 : data.percent * 1 + num;
  data.percent = data.percent.toFixed(2);
  if (data.percent <= 0.95) {
    clearProgressTimer();
    timerId = setTimeout(() => increaseProgress(0.03), 1000);
  } else {
    clearProgressTimer();
  }
};
// 清除定时器的函数
const clearProgressTimer = () => {
  if (timerId) {
    clearTimeout(timerId);
  }
};
// 批量删除取消
const deleteBatchHandleCancel = () => {
  data.deleteBatchVisible = false;
};

const deleteBatch = () => {
  data.percent = 0;
  data.failCount = 0;
  data.successCount = 0;
  data.deleteBatchVisible = true;
};

// 关闭校准
const cancelCaliBration = () => {
  data.calibrationVisible = false;
};

// 打开数据校准弹窗
const openCaliBration = () => {
  data.calibrationVisible = true;
};

// 弹窗关闭回调
const deleteBatchModalClose = () => {
  if (data.isDeleteBatchIng == 2) {
    resetSelected();
  }
  data.isDeleteBatchIng = 0;
  data.maskClosable = true;
};

/*************************************************批量删除******************************************************/

//批量转移
const leadBatch = async () => {
  if (entity.value == 101) {
    //转移线索池
    const params = {
      businessIds: selectTableIds.value,
      poolId: data.poolId,
      title: t('转移线索池')
    };
    poolTransferRef.value.getOptions(params.poolId);
    poolTransferRef.value.transferShow(params);
  } else if (entity.value >= 200) {
    //自定义对象
    const params = {
      title: t('转移'),
      ids: selectTableIds.value,
      changeFlag: entity.value === 2 || entity.value === 3 ? true : false //是否可变更其他负责人
    };
    transferRef.value.transferShow(params);
  } else {
    const params = {
      title: t('转移'),
      ids: selectTableIds.value,
      changeFlag: entity.value === 2 || entity.value === 3 ? true : false //是否可变更其他负责人
    };
    transferRef.value.transferShow(params);
  }
};
//退回
const leadReturn = async () => {
  try {
    const params = {
      businessIds: selectTableIds.value
    };
    const json = await leadsService.clueBackCheck(params);
    if (!json.error) {
      const params = {
        title: t('退回'),
        ids: selectTableIds.value
      };
      returnRef.value.returnShow(params);
    } else {
      Message.error(json.error?.msg || t('操作失败'));
    }
  } catch (e) {
    console.log(e);
  }
};
// Bing数据同步
const batchBingData = async () => {
  setLoading(true);
  // Message.success('数据同步中...');
  // emits('cb', type.value, loading.value);
  try {
    const params = {
      type: entity.value,
      ids: props.bingDataList.value
      // ids: selectTableIds.value
    };
    const json = await publicService.refreshData(params);
    if (!json.error) {
      //   console.log(147, json.result);
      Message.success('数据同步中，同步完成后将自动刷新数据');
    } else {
      Message.error(json.error?.msg || '数据同步失败，请重试!');
    }
    setLoading(false);
    resetSelected();
  } catch (e) {
    setLoading(false);
    Message.error(e.message || e.statusText || '数据同步失败，请重试!');
  }
};

// 邀请数据同步
const bingUserInviteSync = async () => {
  setLoading(true);
  // Message.success('数据同步中...');
  // emits('cb', type.value, loading.value);
  try {
    const params = {
      type: entity.value,
      ids: props.bingDataList,
      // ids: selectTableIds.value,
      isUserInvite: true,
      isCustomer: false
    };
    const json = await publicService.refreshData(params);
    if (!json.error) {
      //   console.log(147, json.result);
      Message.success('数据同步中，同步完成后将自动刷新数据');
    } else {
      Message.error(json.error?.msg || '数据同步失败，请重试!');
    }
    setLoading(false);
    resetSelected();
  } catch (e) {
    setLoading(false);
    Message.error(e.message || e.statusText || '数据同步失败，请重试!');
  }
};

// 重置选择框的选中状态
const resetSelected = () => {
  if (props.tableDataLength == data.successCount) {
    emits('cb', { setPage: true });
  } else {
    emits('cb');
  }
};
const bulkEditingRef = ref();
// 批量编辑
const bulkEditingClick = () => {
  console.log('点击批量编辑');
  bulkEditingRef.value?.open({
    selectTableIds: selectTableIds.value,
    entity: entity.value,
    viewId: props.viewId,
    listFields: props.listFields
  });
};

const stopWatch = watch(
  () => entity.value,
  (v) => {
    if (v >= 200) {
      oem.value[v] = v;
    }
  },
  {
    immediate: true
  }
);
onMounted(() => {
  getBtnPermissionObj();
});
onUnmounted(() => {
  clearProgressTimer();
  stopWatch();
  if (timerSId) {
    clearTimeout(timerSId);
  }
});
</script>
<style scoped lang="less">
@import './ly-list-batch-buttons.less';
</style>
